// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__jDHeM","author":"Table_author__16yD7","authorImage":"Table_authorImage__3lG_Y","unreadRow":"Table_unreadRow__2N0lG"};